import React from 'react';
import {sx} from './sx'
import {Box} from '@mui/material';
import {SxType} from "@baseTypes/sx/sxTypes";
import EmptyLineSingleVoyage from "@containers/singleVoyage/views/stepperLine/line/EmptyLineSingleVoyage";
import {classNames} from "@helpers/classNames";

interface IProps {
    number: number,
    color?: string,
    backgroundColor?: string,
    sx?: SxType,
    sxInner?: SxType,
    active?: boolean,
    onClick?: () => void,
    showLine?: boolean
}

const SteepItemCircleSingleVoyage = ({
                             number,
                             color,
                             backgroundColor,
                             active,
                             sx: sxProps = {},
                             sxInner: sxInner = {},
                             onClick,
                             showLine = true
                         }: IProps) => {
    return (
        <Box
            sx={{
                ...sx.inner,
                ...sxInner
            }}
        >

            {showLine && <EmptyLineSingleVoyage
                active={active}
            />}

            <Box
                onClick={onClick}
                sx={{
                    ...sx.root,
                    color: color ?? '#222',
                    backgroundColor: backgroundColor ?? '#f17878',
                    ...sxProps,
                }}
                className={classNames(onClick && 'hover')}
            >
                {number}

            </Box>
        </Box>
    );
};

export default SteepItemCircleSingleVoyage;